module.exports = __webpack_public_path__ + "static/img/sm_1.39d82ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_1.png
// module id = U+NQ
// module chunks = 0